module.exports = __webpack_public_path__ + "static/media/Hair and Beauty Workshops.ea5baee2.png";